import React, { memo } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import DashboardChartCard from "./DashboardChartCard";

const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 0 };
const INFLOW_COLOR = "#5b9cf5";
const OUTFLOW_COLOR = "#34d399";

const CompletionTrendChart = ({ points = [], teamView = "ic" }) => (
  <DashboardChartCard
    title={teamView === "ic" ? "Completion Trend" : "Completion Trend — Team"}
    subtitle="Tasks created vs completed"
  >
    <div className="dashboard-chart-scroll-container">
      <div style={{ minWidth: `max(100%, ${(points?.length || 0) * 40}px)`, height: 220 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={CHART_MARGIN}>
        <CartesianGrid vertical={false} stroke="#f0f1f3" />
        <XAxis
          dataKey="period"
          tick={{
            fill: "#5b5b5c"
            , fontSize: 12
          }}
          axisLine={false}
          tickLine={false}
          dy={8}
        />
        <YAxis
          tick={{
            fill: "#5b5b5c"
            , fontSize: 12
          }}
          axisLine={false}
          tickLine={false}
          width={32}
        />
        <Tooltip
          cursor={{ stroke: "#e5e7eb" }}
          contentStyle={{
            borderRadius: 8,
            border: "1px solid #e8eaed",
            fontSize: 12,
          }}
        />
        <Legend
          verticalAlign="top"
          height={36}
          iconType="square"
          wrapperStyle={{ fontSize: "12px", paddingBottom: "8px" }}
        />
        <Line
          type="monotone"
          dataKey="inflow"
          name="Created"
          stroke={INFLOW_COLOR}
          strokeWidth={2}
          dot={{ r: 4, fill: INFLOW_COLOR, stroke: "#fff", strokeWidth: 2 }}
          activeDot={{ r: 5 }}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="outflow"
          name="Completed"
          stroke={OUTFLOW_COLOR}
          strokeWidth={2}
          dot={{ r: 4, fill: OUTFLOW_COLOR, stroke: "#fff", strokeWidth: 2 }}
          activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
  </DashboardChartCard>
);

export default memo(CompletionTrendChart);
